// extracted by mini-css-extract-plugin
export default {"base":"Organizations_base__xpvIb","cell":"Organizations_cell__LxbK7"};